import Constants from '../constants'

const { auditActionsEventTypes } = Constants

export default (axios) => ({
  async getAuditActions(queryParams) {
    const {
      action,
      actionContext,
      userId,
      userName,
      clientId,
      documentName,
      dateFilter,
      allReports,
      sort,

      // pagination
      page,
      pageSize,
    } = queryParams

    const params = {
      $orderby: sort || 'timestamp desc',
      $top: pageSize,
      $skip: pageSize * (page - 1),
    }

    const filters = [
      action && `contains(action,'${action}')`,
      actionContext && `contains(actionContext,'${actionContext}')`,
      userId && `userId eq ${userId}`,
      userName && `contains(userName,'${userName}')`,
      clientId && `clientId eq ${clientId}`,
      documentName && `contains(documentName,'${documentName}')`,
      !allReports && `timestamp ge ${dateFilter.startDate.toISOString().split('T')[0]}T00:00:00.000Z`,
      !allReports && `timestamp le ${dateFilter.endDate.toISOString().split('T')[0]}T23:59:59.999Z`,
    ]

    if (filters.filter(Boolean).join(' and ') || null) {
      params.$filter = filters.filter(Boolean).join(' and ')
    }

    const response = await axios.get('/AuditActions/report', { params })

    return response.data
  },

  async logAuditAction(actionData) {
    const { reportId, documentId, actionType } = actionData

    let endpoint = '/AuditActions/'

    switch (actionType) {
      case auditActionsEventTypes.CLICK:
        endpoint += 'log-click'
        break
      case auditActionsEventTypes.PREVIEW:
        if (documentId) endpoint += 'log-document-preview'
        if (reportId) endpoint += 'log-report-preview'
        break
    }

    const req = await axios.post(endpoint, actionData)
    return req.data
  },

  customAuditActions: {
    // click events
    click_calculateFinancialImpactButton: 'CALCULATE_FINANCIAL_IMPACT_BUTTON_CLICK',

    // File preview events
    preview_assetReportFile: 'ASSET_REPORT_FILE_PREVIEW',
    preview_summaryAssetReportFile: 'SUMMARY_ASSET_REPORT_FILE_PREVIEW',
    preview_8925ReportFile: '8925_REPORT_FILE_PREVIEW',
    preview_OtherReportsFile: 'REPORT_FILE_PREVIEW',
  },
})
